//@flow
import React from 'react';
import s from './SectionHeader.less';
import {numberToFixed} from '../../../../helpers';

type Props = {
  cost?: number,
  title: string,
};

const SectionHeader = (props: Props) => {
  const sectionColor = props.title ? props.title.split (' ')[0] : '';

  return (
    <div className={`${s.sectionHeader}`}>
      <div className={`${s.sectionHeaderContent}`}>
        <h2 className={`${s.noMargin} ${sectionColor}`}>{props.title}</h2>
          {props.title ==='Labor Cost' && (<div><h4 style={{marginRight:'38px'}} className={`${s.noMargin}`}>Std.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Obsv.</h4></div>)}
        {typeof props.cost === 'number'
          ? <h3 className={`${s.noMargin}`}>
              {props.cost < 0
                ? `-$${numberToFixed (props.cost, 2) * -1}`
                : `$${numberToFixed (props.cost, 2)}`}
            </h3>
          : null}
      </div>
      <div className={`${s.hr}`} />
    </div>
  );
};

export default SectionHeader;



// WEBPACK FOOTER //
// ./src/components/SummarySubSections/SummarySubSection/SectionHeader/SectionHeader.js